import { useTheme } from '@mui/material';

import React from 'react';
import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';

const LoadingButtonIndicator = () => {
  const theme = useTheme();
  return (
    <CustomizedCircularProgress
      size={22}
      customColor2={theme.palette.grey[50]}
      customColor={theme.palette.common.white}
    />
  );
};
export default LoadingButtonIndicator;
